<div class="container mt-card">
    <div class="row justify-content-center">
        <div class="col-lg-12" *ngIf="complaintDetails">
            <div class="col-lg-12">

                <h1 class="text-center">Ticket {{complaintID}}</h1>
                <h5 class="text-primary text-center text-muted" *ngIf="complaintDetails.status=='CLOSED'">This ticket
                    has been CLOSED</h5>
                <div class="card-body">
                    <!-- First last and other Names -->
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Candidate Number.</label>
                                <p class="form-control">{{complaintDetails.examNo}}</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Examination Schedule Status</label>
                                <p class="form-control">{{complaintDetails.scheduleStatus}}</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Examination Schedule Start Time</label>
                                <p class="form-control">{{this.getDatestrings(complaintDetails.scheduleStartDateTime)}}
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="row mt-3">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ticket Submittion Date</label>
                                <p class="form-control">{{this.getDatestrings(complaintDetails.submittedDate)}}</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ticket Status</label>
                                <p class="form-control">{{complaintDetails.status}}</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ticket Category </label>
                                <p class="form-control">{{complaintDetails.complaintCategory.categoryID}}</p>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <legend class="conversation-legend"> Support Discussion</legend>
                    <div class="response-container mb-3" #responseContainer>

                        <div *ngFor="let response of complaintDetails.responses">
                            <div class="row mb-3">
                                <div
                                    [ngClass]="{'col-8': !response.isAdminResponse, 'col-8 offset-4': response.isAdminResponse}">
                                    <div class="response-content">
                                        <small class="text-muted">
                                            <b> {{ response.sentBy }}</b>
                                        </small>
                                        <div [innerHTML]="response.response" class="p-3 response-box"></div>
                                        <small class="text-muted">{{this.getDatestrings(response.responseDate)
                                            }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="m-3">
                        <div class="mb-1">
                            <div class="mb-2">
                                <h5>Possible Placeholder Options</h5>
                                <p>Use the following placeholders to customize your message. <span
                                        class="text-primary">Click on the
                                        placeholder to copy it</span></p>
                                <ul class="flex-grid">
                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{candidate_fullname}', $event)">
                                        Candidate Fullname
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{exam_name}', $event)">
                                        Exam Name
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{exam_start_datetime}', $event)">
                                        Exam Start Datetime
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{exam_end_datetime}', $event)">
                                        Exam End Datetime
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{exam_duration}', $event)">
                                        Exam Duration
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{schedule_start_datetime}', $event)">
                                        Schedule Start Datetime
                                    </span>

                                    <span class="btn btn-outline-secondary placeholder-tag"
                                        (click)="copyPlaceholder('{schedule_end_datetime}', $event)">
                                        Schedule End Datetime
                                    </span>


                                </ul>

                                <!-- Toast -->
                                <div *ngIf="toast.visible" class="copy-toast"
                                    [ngStyle]="{ top: toast.y + 'px', left: toast.x + 'px' }">
                                    Copied and inserted!
                                </div>

                            </div>
                            <h1 class="qustion"> Reply:</h1>
                            <quill-editor #editor [(ngModel)]="response" name="response"
                                (onEditorCreated)="onEditorReady($event)">
                            </quill-editor>
                            <div class="form-check m-2">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="closeCM" name="closeCM" id="closeCM">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Close Ticket With Reply
                                </label>
                            </div>
                        </div>
                        <div class="form-footer d-flex">
                            <button type="button" id="prevBtn" class="mr-2" (click)="closeBtnClick()"
                                [disabled]="complaintDetails.status=='CLOSED'">
                                Close Ticket</button>
                            <button type="button" id="nextBtn" (click)="submitBtnClick()" [disabled]="!response">Reply
                                Ticket</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="justify-content-center" *ngIf="!complaintDetails">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">No Ticket Found</h4>
                <p>Sorry, we could not find the complaint you are looking for.</p>
            </div>

        </div>
    </div>
</div>